import { TableCell, TableRow, Typography } from '@mui/material';

// todo MATAN: langauge, colors, style file

const MESSAGE = 'No Results';

type TalentsEmptyStateProps = {
  tableColumnsCount: number,
}

const TalentsEmptyState = ({
  tableColumnsCount,
}: TalentsEmptyStateProps):JSX.Element => {
  return (
    <TableRow>
      <TableCell
        colSpan={ tableColumnsCount }
        color="secondary"
      >
        <Typography variant="overline" sx={ { color: '#6B7280' } }> {MESSAGE} </Typography>
      </TableCell>
    </TableRow>
  );
};

export default TalentsEmptyState;
